/**
 * <lp-vehicle-finder> — sends the finder form to the chosen department.
 *
 * The form works without this file: it is a GET form to /collections/all whose van select is
 * named as the Vehicle filter (filter.p.m.custom.vehicle_fitment), and the department select has
 * no name, so it never reaches the URL. All this does is point the form at the department's
 * collection when one is picked, so the van filter lands there instead.
 *
 * The action is set on every submit, back to the default when "All parts" is chosen, because a
 * page restored from the back/forward cache keeps whatever action the last submit left.
 *
 * Markup contract, see snippets/lp-vehicle-finder.liquid:
 *   <lp-vehicle-finder>
 *     <form action="/collections/all" method="get">
 *       <select name="filter.p.m.custom.vehicle_fitment" required>…</select>
 *       <select data-lp-finder-department>
 *         <option value="">All parts</option>
 *         <option value="/collections/…">…</option>
 *       </select>
 *     </form>
 *   </lp-vehicle-finder>
 */
class LpVehicleFinder extends HTMLElement {
  #form = null;
  #defaultAction = '';

  connectedCallback() {
    this.#form = this.querySelector('form');
    if (!this.#form) return;
    this.#defaultAction = this.#form.getAttribute('action');
    this.#form.addEventListener('submit', this.#onSubmit);
  }

  disconnectedCallback() {
    this.#form?.removeEventListener('submit', this.#onSubmit);
  }

  #onSubmit = () => {
    const department = this.querySelector('[data-lp-finder-department]');
    this.#form.setAttribute('action', department?.value || this.#defaultAction);
  };
}

if (!customElements.get('lp-vehicle-finder')) {
  customElements.define('lp-vehicle-finder', LpVehicleFinder);
}
